import request from '@/utils/request'

// 温馨提示管理API
export const tipApi = {
  // 分页查询温馨提示
  getTipList(params) {
    return request({
      url: '/warm-tip/list',
      method: 'get',
      params
    })
  },

  // 根据提示ID获取提示详情
  getTipDetail(tipId) {
    return request({
      url: `/warm-tip/detail/${tipId}`,
      method: 'get'
    })
  },

  // 添加温馨提示
  addTip(data) {
    return request({
      url: '/warm-tip/add',
      method: 'post',
      data
    })
  },

  // 更新温馨提示
  updateTip(data) {
    return request({
      url: '/warm-tip/update',
      method: 'post',
      data
    })
  },

  // 删除温馨提示
  deleteTip(tipId) {
    return request({
      url: `/warm-tip/delete/${tipId}`,
      method: 'delete'
    })
  }
}